import { Route, Routes } from "react-router-dom";
import { UserRoles } from "../../../constants/userRoles";
import { PrivateRoute } from "../../../keycloak";
import { ClientList } from "./ClientList/ClientList";
import { ClientView } from "./ClientView";

export const Client = () => {
  return (
    <div>
      <Routes>
        <Route
          element={
            <PrivateRoute
              roles={{
                dcs_client: [UserRoles.CLIENT_VIEW],
              }}
            />
          }
        >
          <Route path={`:clientId/*`} element={<ClientView />} />
          <Route index path="/" element={<ClientList />} />
        </Route>
      </Routes>
    </div>
  );
};
